import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

/**
 * Closing call-to-action block that points to the full inspiration feed.
 * Full-width dark panel with decorative background glows.
 */
export function DemandInspirationCtaBlock() {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden="true" className="absolute inset-0 opacity-[0.08] [background-image:linear-gradient(to_right,white_1px,transparent_1px),linear-gradient(to_bottom,white_1px,transparent_1px)] [background-size:40px_40px]" />;
    t1 = <div aria-hidden="true" className="absolute -left-40 -top-40 h-[500px] w-[500px] rounded-full bg-[#ff5a36]/20 blur-[120px]" />;
    t2 = <div aria-hidden="true" className="absolute -bottom-32 -right-32 h-[400px] w-[400px] rounded-full bg-[#4fc3a1]/15 blur-[100px]" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 className="mt-6 text-4xl font-black leading-[0.95] tracking-[-0.035em] text-white sm:text-5xl lg:text-6xl">You now know the essentials. Now steal what works, add your own twist, and do it for your business.</h2>;
    t4 = <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-white/70">See real examples of what other brands and businesses are doing to drive demand and convert it, then do it for your business.</p>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <section className="relative isolate overflow-hidden bg-[#211d4f] px-5 py-20 sm:px-8 sm:py-28 lg:px-12">{t0}{t1}{t2}<div className="relative mx-auto max-w-[1320px] text-center">{t3}{t4}<div className="mt-8 flex flex-col items-center gap-4 sm:flex-row sm:justify-center"><Link href="/inspiration-feed" className="group inline-flex cursor-pointer items-center gap-3 rounded-lg bg-[#ff5a36] px-8 py-4 text-base font-black text-white shadow-[0_4px_20px_rgba(255,90,54,0.4)] transition-all hover:bg-[#ff7354] hover:shadow-[0_6px_30px_rgba(255,90,54,0.5)]">Browse the Inspiration Feed<ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" aria-hidden="true" /></Link></div></div></section>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}